import { createSelector } from 'reselect';

const selectJourneyLeg = (state: any) => state.journeyLeg;

export const selectJourneyLegCurrentItem = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.current);

export const selectJourneyLegListItems = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.list);

export const selectJourneyLegItemById = (itemId: any) =>
    createSelector(selectJourneyLegListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectJourneyLegCreatedItem = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.create);

export const selectJourneyLegQueryItems = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.query);

export const selectJourneyLegUpdatedItem = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.update);

export const selectJourneyLegReadItem = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.read);

export const selectJourneyLegDeletedItem = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.delete);

export const selectJourneyLegSearchedItems = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.search);

export const selectJourneyLegItemsCount = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.count);

export const selectJourneyLegItemsFilter = createSelector([selectJourneyLeg], (journeyLeg) => journeyLeg.filter);